module.exports = __webpack_public_path__ + "static/media/archive.97582ec6.svg";